import { connect, MapStateToProps } from 'react-redux'
import { Props } from './EnterVehicleCodeButton'
import brandSelector from '../../redux/selectors/brandSelector'
import isVinEnabledSelector from '../../redux/selectors/feature-scope/isVinEnabledSelector'
import isVehicleCodeEnabledSelector
    from '../../redux/selectors/feature-scope/isVehicleCodeEnabledSelector'

type StateProps = Pick<Props, 'brand' | 'vehicleCodeEnabled' | 'vinEnabled'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state) => ({
    brand: brandSelector(state),
    vehicleCodeEnabled: isVehicleCodeEnabledSelector(state),
    vinEnabled: isVinEnabledSelector(state),
})

export default connect(mapStateToProps)
